module.exports = __webpack_public_path__ + "img/w3_cykel_black.456eb1b0.png";